import { createContext, useContext, useEffect, useState } from "react";

import LoginPage from "../components/LoginPage";

export const UserContext = createContext();

export const UserContextProvider = ({ children }) => {
    const [dealerDetail, setDealerDetail] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);


    useEffect(() => {
        const fetchUserDetail = async () => {
            try {
                const userDetail = await window.catalyst.auth.isUserAuthenticated();
                const mainData = userDetail?.content;

                // 🔹 Developer credit – logs only once
                console.log(
                    `%c
╔══════════════════════════════╗
║                              ║
║    %cDeveloped by Shivani Bhardwaj ✨%c    ║
║                              ║
╚══════════════════════════════╝`,
                    "color: #16a34a; font-weight: 600; font-family: 'SF Mono', monospace; font-size: 16px; line-height: 1.2;",
                    "color: #f33333ff; font-weight: 700; font-size: 18px;",
                    "color: transparent;"
                );




                console.log(mainData);
                const user_id = mainData?.user_id;
                const user_email = mainData?.email_id;
                const fname = mainData?.first_name;
                const lname = mainData?.last_name;

                if (!user_id) {
                    throw new Error("User ID is undefined");
                }

                const response = await fetch("/server/dealer_backend/user-detail", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        id: user_id,
                        email: user_email,
                        first_name: fname,
                        last_name: lname,

                    }),
                });

                if (!response.ok) {
                    throw new Error(`API error: ${response.status} ${response.statusText}`);
                }

                const responseJson = await response.json(); // Read response only once
                console.log("Fetched response:", responseJson);

                const accountDetails = responseJson?.accountDetails;
                if (!accountDetails) {
                    throw new Error("Unexpected response structure: No account details found");
                }

                setDealerDetail(accountDetails);
            } catch (error) {
                console.error("Error fetching user details:", error);
                setError(error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchUserDetail();
    }, []);

    return (
        <UserContext.Provider value={{ dealerDetail }}>
            {isLoading ? (
                <div className="flex h-screen w-screen justify-center items-center">
                    {/* <Spinner  color="failure" aria-label="Loading..." size="sm" /> */}
                </div>
            ) : dealerDetail ? (
                children
            ) : (
                <LoginPage />
            )}
        </UserContext.Provider>
    );
};
export const useUserContext = () => {
    return useContext(UserContext);
};